const reBankClearingnummer = /^((\d{4,5})|(\d{4}-\d))$/

module.exports = function normalizeSvensktBankClearingnummer(input) {
  const match = reBankClearingnummer.exec(input.replace(/\s/g, ''))

  if (!match) return input

  const matched = match[0]
  if (matched.length === 5) {
    return `${matched.substr(0, 4)}-${matched.substr(4, 1)}`
  }
  return matched
}
